// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { LabeledInput } from 'components/Form'
import { Lookup } from 'components/index'
import usePathDatabaseSearchAntennaLookup from 'components/SearchAndSelect/Sets/common/AntennaField/AntennaCode/hooks/usePathDatabaseSearchAntennaLookup'

const lookupFormName = 'antenna-lookup'

const AntennaCode = props => {
  const {
    idRoot,
    sourceForm,
  } = props

  const {
    assignAntenna,
    getLookupTypeProps,
  } = usePathDatabaseSearchAntennaLookup(sourceForm, lookupFormName)

  return (
    <>
      <Field
        clearable={() => assignAntenna(null)}
        component={LabeledInput}
        id={`${idRoot}antenna-code`}
        label={''}
        name={'antennaCode'}
        placeholder={'Antenna Code'} />
      <Lookup
        getLookupTypeProps={getLookupTypeProps}
        lookupFormName={lookupFormName}
        lookupLabel={'Antenna Lookup'}
        lookupType={'antenna'}
        selectRow={assignAntenna}
        triggerId={`${idRoot}antenna-lookup-trigger`} />
    </>
  )
}

AntennaCode.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default AntennaCode
